var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"background",class:_vm.$mq,style:(_vm.backgroundStyles),attrs:{"w-100":"","h-100":"","fx":"","fxcenter":"","fxacenter":""}},[_c('img',{staticClass:"logo",class:_vm.$mq,style:(_vm.logoStyles),attrs:{"src":_vm.logoImage,"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }